import styled from 'styled-components';
import { SectionHeading } from '../../global/typography';

export const StyledHeading = styled(SectionHeading)`
    text-align: left;
    color: white;
    margin-bottom: 15px;
`;

export const StyledTitle = styled(SectionHeading)`
    text-align: center;
    margin-bottom: 30px;
`;